import i18n from '@/lang/i18n'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { PaginatorDatasource } from '@/shared/resources/datasources/paginator/paginator-datasource'
import { sampleProcessesConfigurationServices } from '@/api/resources/configuration/samples/sampleProcesses/sampleProcessServices'
import { initialCrudModelBaseState, CrudModelBase } from '@/shared/models/cruds.models'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { TranslationRequest, TranslationResponse } from '@/api/services/common.dto'
import { Nullable } from '@/shared/types/app.types'

export const columnsDefSampleProcessesGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            headerName: i18n.tc('configuration.grid.code'),
            type: AgGridColumnType.NUMBER,
            field: 'code',
            minWidth: 80
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.processesType'),
            colId: 'nameTranslationKey',
            field: 'name',
            minWidth: 280,
            flex: 1
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            flex: 2
        },
        {
            type: AgGridColumnType.FLAGS_RENDERER,
            headerName: i18n.tc('configuration.grid.translations'),
            field: 'nameTranslations',
            filter: false,
            sortable: false,
            flex: 2
        }
    ]

export interface ConfigurationSampleProcessRequest {
    active: boolean
    code: number,
    nameTranslations: TranslationRequest[]
}

export interface IContentSampleProcessesGrid {
    active: boolean
    code: Nullable<number>
    id?: number
    name?: string
    nameTranslations: TranslationResponse[]
}
export const initialSampleProcessesModalState =
    (): IContentSampleProcessesGrid => ({
        id: undefined,
        code: null,
        name: '',
        active: false,
        nameTranslations: []
    })

export type ISampleProcessesGridState = CrudModelBase<IContentSampleProcessesGrid>
export const initialSampleProcessesGridState =
    (): ISampleProcessesGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.global.samples.processesTypes',
        columnsDef: columnsDefSampleProcessesGrid(),
        datasource: new PaginatorDatasource(sampleProcessesConfigurationServices)
    })
